import React from 'react';
import { WysiwygBlock } from '../../models/ecd-block-models';
import { Wysiwyg } from '../wysiwyg';

interface Props {
    blockData: WysiwygBlock,
}

function WysiwygBlockView(props: Props){

    const { blockData } = props;        

    return (
        <section className="adage-block">            
            <Wysiwyg content={blockData?.wysiwygContent} />            
        </section>
    );
}

export default WysiwygBlockView;
